// Validation function
function validate() {
  let submit = document.getElementById("check6");

    /* First name validation */
    let first = document.getElementById("name").value;
    if (first == "") {
      document.getElementById("check").innerHTML = "*Name can't be blank*";
      return false;
    } else {
      document.getElementById("check").innerHTML = "";
    }
  /* Email validation */
  let mail = document.getElementById("email").value;
  if (mail == "") {
    document.getElementById("check2").innerHTML = "*Email can't be blank*";
    return false;
  } else if (
    mail.indexOf("@") <= 0 ||
    mail.lastIndexOf(".") <= mail.indexOf("@")
  ) {
    document.getElementById("check2").innerHTML = "*Invalid email format*";
    return false;
  } else {
    document.getElementById("check2").innerHTML = "";
  }

  /* Phone number validation */
  let num = document.getElementById("phone").value;
  if (num == "") {
    document.getElementById("check3").innerHTML =
      "*Phone number can't be blank*";
    return false;
  } else {
    document.getElementById("check3").innerHTML = "";
  }

  /* Company name validation */
  let company = document.getElementById("companyname").value;
  if (company == "") {
    document.getElementById("check4").innerHTML =
      "*Company name can't be blank*";
    return false;
  } else {
    document.getElementById("check4").innerHTML = "";
  }

  /* Website Url name validation */
  let website = document.getElementById("website").value;
  if (website == "") {
    document.getElementById("check5").innerHTML =
      "*Website Url can't be blank*";
    return false;
  } else {
    document.getElementById("check5").innerHTML=""
  }
  // meassage validation

  let message = document.getElementById("message").value

  if(message == ""){
    document.getElementById("check7").innerHTML =
    "*Message box can't be blank*";
    return false;
  }
  else{
    document.getElementById("check7").innerHTML =
    "";
  }

  return true;
}
// return true; // Return true if all validations pass

// Form submission event listener
document
  .getElementById("contactForm")
  .addEventListener("submit", function (event) {
    event.preventDefault();

    // Validate the form
    if (!validate()) {
      // If validation fails, do not proceed with form submission
      return;
    }

    // If validation passes, proceed with form submission
    const formData = new FormData(this);
    const jsonObject = {};
    formData.forEach((value, key) => {
      jsonObject[key] = value;
      console.log(value);
    });
    console.log(jsonObject)

    fetch("https://maculatech.com/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonObject),
    })
      .then((response) => {
      return   console.log(response)
      })
      .then((data) => {
        // Success message
        showToast("success", data.message);
        document.getElementById("contactForm").reset(); // Reset form after successful submission
         
      })
      .catch((error) => {
        // Error message
        showToast("error", "An error occurred while submitting the form.");
        console.error("Error:", error);
      });
  });

// Toast function
const showMessage = document.getElementById("check6")
function showToast(type, message) {
 showMessage.innerHTML= message
  setTimeout(() => {
    showMessage.innerHTML=""
  }, 3000); // Adjust the timeout as needed
}
